export default "__VITE_ASSET__4dca64ea__"